import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BulkPatchPayloadType_NDC, NdcCodesContent, NdcCodesState, PatchPayloadTypeNDC, PayloadGetNdcCodesByPageType, PayloadGetSingleNdcCodesType } from '../types/ndcCodes.types'

const initialState: NdcCodesState = {
  content: [],
  selected: null,
  totalPages: null,
  selectedProduct : null,
}

const NdcCodesSlice = createSlice({
  name: 'ndcCodes',
  initialState: initialState,
  reducers: {
    updateNdcCodesData: (state :NdcCodesState, action: PayloadAction<NdcCodesContent[] | null>) => {
      state.content = action.payload
    },
    updateSelectedNdcCodes: (state : NdcCodesState, action : PayloadAction<NdcCodesContent | null>) => {
      state.selected = action.payload
    },
    resetSelectedNdcCodes: (state) => {
      state.selected = null
    },
    updateNdcCodesByPage: (state: NdcCodesState, action) => {
      if (action?.payload.data) {
        state.content = action?.payload?.data?.content
        state.totalPages = action?.payload?.data?.totalPages
      }
    },
    getAllNdcCodesByPageAction : (
      state: NdcCodesState,
      _action: PayloadAction<PayloadGetNdcCodesByPageType>)=> {return state},

    getAllNdcCodesAction: () => {return},
    getSingleNdcCodesAction: (state: NdcCodesState,
      _action: PayloadAction<PayloadGetSingleNdcCodesType>) => {return state},

    createNdcCodesAction: (state : NdcCodesState , _action) => {return state},
    updateNdcCodesAction: (state : NdcCodesState , _action) => {return state},
    getNdcCodesDataBySortAction: () => {
      return;
    },
    getSelectedProductActioninNdcCodes: (state , _action) => {
      return state
    },
    updateSelectedAddProductsinNdcCodes: (state, action) => {
      state.selectedProduct = action.payload
    },
    patchToggleUpdateActionNdcCodes: (state : NdcCodesState , _action : PayloadAction<PatchPayloadTypeNDC>) => {
      return state;

    },
    patchToggleUpdateBulkActionNdcCodes: (state : NdcCodesState , _action : PayloadAction<BulkPatchPayloadType_NDC>) => {
      return state;
    },
  },
})

export const {
  updateNdcCodesData,
  updateSelectedNdcCodes,
  resetSelectedNdcCodes,
  updateNdcCodesByPage,
  getAllNdcCodesByPageAction,
  getAllNdcCodesAction,
  getSingleNdcCodesAction,
  createNdcCodesAction,
  updateNdcCodesAction,
  getNdcCodesDataBySortAction,
  getSelectedProductActioninNdcCodes,
  updateSelectedAddProductsinNdcCodes,
  patchToggleUpdateActionNdcCodes,
  patchToggleUpdateBulkActionNdcCodes,
} = NdcCodesSlice.actions
export default NdcCodesSlice.reducer
